// Update user's preferred language if weglot language changes
if (typeof Weglot !== "undefined") {
  Weglot.on("languageChanged", function (newLang, prevLang) {
    // Bug on production caused infinite reload loop without this
    if (prevLang == "") { return }

    const formData = new FormData();

    if (gon.user_id) {
      formData.append("user[preferred_language]", newLang);
      Rails.ajax({
        type: "PUT",
        url: `/users`,
        data: formData,
        success: function () {
          setTimeout(() => { location.reload(); }, 100) // To make sure backend translations also load
        }
      });
    } else {
      formData.append("locale", newLang);
      Rails.ajax({
        type: "POST",
        url: `/set_locale_from_weglot`,
        data: formData,
        success: function () {
          setTimeout(() => { location.reload(); }, 100) // To make sure backend translations also load
        }
      });
    }

    // If user has a preferred language set, switch weglot to that
    if (gon.preferred_language && gon.preferred_language != Weglot.getCurrentLang()) {
      Weglot.switchTo(gon.preferred_language);
    }
  });
}